<template>
  <div
    class="fixed left-0 top-0 w-screen h-screen bg-black bg-opacity-50"
    @click="$emit('close')"
  >
    <div
      class="
        dialog-height
        flex flex-col
        m-auto
        mt-10
        p-6
        max-w-5xl
        bg-white
        rounded-t-3xl
        md:rounded-b-3xl
      "
      @click.stop
    >
      <div
        class="
          relative
          flex flex-shrink-0
          items-center
          justify-center
          py-4
          border-b border-gray-1
        "
      >
        <span class="text-xl font-semibold">{{
          $t('common.privacyPolicy2')
        }}</span>
        <button
          class="absolute right-0 flex items-center justify-center w-9 h-9"
          @click="$emit('close')"
        >
          <IconClose />
        </button>
      </div>
      <div class="flex-grow py-3">
        <iframe
          v-if="regulationsUrl"
          :src="regulationsUrl"
          class="w-full h-full"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconClose from '@/components/IconClose.vue';

@Component({ components: { IconClose } })
export default class RegulationsDialog extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) regulationsUrl!: string;
}
</script>
<style scoped>
.dialog-height {
  height: calc(100vh - 10%);
  max-height: 1220px;
}

@media (max-width: 769px) {
  .dialog-height {
    height: calc(100% - 36px);
  }
}
</style>
